import React, { useContext } from 'react'
import * as locales from 'date-fns/locale'
import Header from './Header/Header'
import { Calendar } from './Calendar/Calendar'
import { DatePickerContext, DatePickerProvider } from './DatePickerProvider'
import { PresetDates } from './Calendar/PresetDates'
import { useTranslation } from 'react-i18next'
import StateIcon from 'components/global/StateIcon'
import { Box } from '@mui/material'
import {
  DatePickerCard,
  FlexBox,
  ContentStack,
  HeaderTypography,
  CalendarStack,
  ButtonsContainer,
  ButtonsBox,
  StyledButton
} from './DatePicker.styles'

const Buttons = ({ closeLabel, confirmLabel, showReset }) => {
  const { onApply, onCancel, onReset, editMode } = useContext(DatePickerContext)
  const { t } = useTranslation()

  const handleCancel = () => {
    onReset()
    onCancel()
  }

  return (
    <ButtonsContainer>
      {showReset && !editMode && (
        <StyledButton
          onClick={onReset}
          variant="outlined"
          startIcon={<StateIcon iconlabel="arrow-rotate-left" iconweight="regular" iconsize="12px !important" />}
        >
          {t('datepicker.actions.reset')}
        </StyledButton>
      )}
      <ButtonsBox showreset={showReset && !editMode ? 1 : 0}>
        <StyledButton onClick={handleCancel} variant="outlined">
          {closeLabel}
        </StyledButton>
        <StyledButton onClick={onApply} variant="contained" color="primary">
          {confirmLabel}
        </StyledButton>
      </ButtonsBox>
    </ButtonsContainer>
  )
}

export default ({
  locale = 'fr',
  blockFutureDates = false,
  blockPastDates = false,
  showPresets = false,
  showPresetLabel = false,
  placement = 'bottom-start',
  singleDateMode = false,
  editMode = false,
  ...props
}) => {
  const { t } = useTranslation()

  const handleClose = () => {
    props.onReset?.()
    props.onClose?.()
  }

  return (
    <DatePickerProvider
      locale={locales[locale]}
      blockFutureDates={blockFutureDates}
      blockPastDates={blockPastDates}
      placement={placement}
      showPresetLabel={showPresetLabel}
      singleDateMode={singleDateMode}
      editMode={editMode}
      onClose={handleClose}
      {...props}
    >
      <DatePickerCard showpresets={showPresets && !editMode ? 1 : 0}>
        <FlexBox>
          {showPresets && !editMode && <PresetDates />}
          <ContentStack>
            {showPresets && !editMode && (
              <HeaderTypography>
                {t('datepicker.headers.specific')}
              </HeaderTypography>
            )}
            <CalendarStack>
              {!singleDateMode && <Header />}
              <Calendar />
            </CalendarStack>
          </ContentStack>
        </FlexBox>
        <Box sx={{ position: 'sticky', bottom: 0, width: '100%' }}>
          <Buttons
            closeLabel={t('ui_elements.form_cancel')}
            confirmLabel={t('ui_elements.form_validate')}
            showReset={showPresets}
          />
        </Box>
      </DatePickerCard>
    </DatePickerProvider>
  )
}
